const loaders = {
  sweet: () => import('./sweet-promo-modal.js'),
  halloween: () => import('./halloween-promo.js'),
  legacy: () => import('./event-promo-modal.js'),
};

/** A format-specific promo wins over a stale theme from the previous event. */
export function loadEventPromo(eventMode, modules = loaders) {
  if (!eventMode?.active) return null;
  if (eventMode.config?.mode === 'halloween') return modules.halloween();
  return eventMode.config?.mode === 'sweet' ? modules.sweet() : modules.legacy();
}
